import { ewaAxiosInstance } from "utils/request"

/**
 * Fire a product-analytics event through the ewa-service Conviso proxy
 * (Pattern B). The browser holds no analytics key — it pings our backend on a
 * successful action and the server forwards to Conviso, deriving identity from
 * the session token. Fire-and-forget: never blocks or throws into the UI.
 *
 * eventName must be one of CLIENT_TRACKABLE_EVENTS on the backend, otherwise
 * the endpoint rejects it with a 400 (silently swallowed here).
 */
export const trackEvent = (
  eventName: string,
  properties?: Record<string, unknown>
) => {
  ewaAxiosInstance
    .post("v1/analytics/track", { eventName, properties })
    .catch(() => {})
}
